import { z } from 'zod';
import { projectTypes, type ProjectType } from '../../config/services';

export { projectTypes, type ProjectType };

const optionalWebsite = z
  .string()
  .trim()
  .max(500)
  .refine((value) => {
    if (!value) return true;
    try {
      const url = new URL(value);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch {
      return false;
    }
  }, 'Please enter a full URL, including https://')
  .optional()
  .default('');

export const projectInquirySchema = z.object({
  name: z.string().trim().min(2, 'Please enter your name.').max(100),
  business_name: z.string().trim().max(120).optional().default(''),
  email: z.string().trim().email('Please enter a valid email address.').max(254),
  country: z.string().trim().min(2, 'Please enter your country.').max(80),
  project_type: z.enum(projectTypes),
  current_website: optionalWebsite,
  project_details: z.string().trim().max(2000).optional().default(''),
  free_preview_requested: z.boolean().default(false),
  company_website: z.string().max(200).optional().default(''),
});

export type ProjectInquiryInput = z.input<typeof projectInquirySchema>;
export type ProjectInquiryValues = z.output<typeof projectInquirySchema>;
export type ProjectInquiryPayload = ProjectInquiryValues & {
  request_id: string;
  started_at: number;
  page_url: string;
  referrer: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  turnstile_token?: string;
};

export const projectInquiryDefaults: ProjectInquiryValues = {
  name: '',
  business_name: '',
  email: '',
  country: '',
  project_type: 'not-sure',
  current_website: '',
  project_details: '',
  free_preview_requested: false,
  company_website: '',
};
